import styled from 'styled-components'

import { Button } from 'components/Button'

import { Color } from 'root-constants'

export const StyledStartQuizAyah = {
  Wrapper: styled.div`
    max-width: 375px;
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;

    padding: 24px;
    margin: 0 auto;
  `,
  Title: styled.h1`
    font-size: 32px;
    line-height: 38px;
    font-weight: 700;
    text-align: center;
    color: ${Color.INK_DARKEST};

    margin-bottom: 8px;
  `,
  Subtitle: styled.span`
    font-size: 20px;
    line-height: 26px;
    font-weight: 500;
    text-align: center;
    color: ${Color.INK_DARKEST};

    margin-bottom: 8px;
  `,
  Note: styled.span`
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    text-align: center;
    color: ${Color.INK_LIGHT};

    padding: 8px 0;
  `,
  Image: styled.img`
    width: 100%;
    max-width: 327px;
  `,
  Button: styled(Button)`
    height: 48px;

    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    white-space: nowrap;
    background-color: ${Color.INK_DARKEST};
    color: ${Color.GOLD_LIGHTER};

    transition: background-color 0.2s ease-out;

    padding: 16px 32px;
    margin: 36px 0;
  `,
  TermsSection: styled.div`
    margin-top: auto;
  `,
  TermsNote: styled.p`
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    text-align: center;
    color: ${Color.INK_LIGHT};

    padding: 24px 0;
  `,
}
